var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirRedflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#EE504F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5803 6.93814C12.5161 6.90069 10.9942 6.03527 9.28757 6.93043C8.23711 7.48192 7.2766 7.18964 6.88815 7.02516V6.52103C6.88815 6.31835 6.72402 6.15387 6.52097 6.15387C6.31793 6.15387 6.15381 6.31835 6.15381 6.52103V7.25537V10.934V14.5987C6.15381 14.8017 6.31793 14.9659 6.52097 14.9659C6.72401 14.9659 6.88813 14.8017 6.88813 14.5987V11.4833C7.17782 11.5766 7.56225 11.6632 8.0102 11.6628C8.4956 11.6628 9.05222 11.5619 9.62904 11.2593C10.9644 10.5573 12.1588 11.2211 12.2121 11.252C12.3248 11.317 12.4647 11.3177 12.5785 11.2523C12.6927 11.1866 12.7628 11.0654 12.7628 10.934V7.25537C12.7628 7.12503 12.6934 7.00387 12.5803 6.93814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirRedflag);
export default __webpack_public_path__ + "static/media/mir_red flag.0022104c5999b10ecb09ba0d663bc124.svg";
export { ForwardRef as ReactComponent };